

















import Vue from 'vue'
export default {
    name: "ServerInfo",
    props: ['packet_conn', 'ytranslate', 'isclient'],
    data() {
        return {
            expanded: false
        }
    },
    computed: {
        lefttrans(){
            if (this.isclient)
                return -210
            else
                return 1000
        },
        buttontrans(){
            if (this.isclient)
                return 240
            else
                return -60       
        }
    },
    methods: {
        toggleSeverInfo(){
            let serverinfo = ( <HTMLElement> this.$el).children[1]
            if (serverinfo.classList.contains('show'))
                serverinfo.classList.remove('show')
            else
                serverinfo.classList.add('show')
            this.expanded = !this.expanded
        }
    },
}
